<template>
  <div class="serviceProgressWrapper">
    <div class="header">
      <Header title="服务进度" />
    </div>
    <div class="content">
      <TimeLine
        :handleQuestionnaire="handleQuestionnaireJump"
        :parentInstanceSn="parentInstanceSn"
        :handleOpenAppPage="openAppPage"
        :userId="userId"
      />
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import Header from '../../../components/Header'
import TimeLine from './components/TimeLine'
const props = defineProps({
  handleQuestion: {
    type: Function
  },
  parentInstanceSn: {
    type: String,
    default: ''
  },
  jumpAppPage: {
    type: Function
  },
  userId: {
    type: String,
    default: ''
  }
})

const handleQuestionnaireJump = progressItem => {
  props.handleQuestion(progressItem)
}
const openAppPage = url => {
  props.jumpAppPage(url)
}
</script>

<style scoped lang="scss">
.serviceProgressWrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  .header {
    position: sticky;
    top: 0;
    z-index: 9;
    background: #fff;
    margin-bottom: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid #eff4f9;
  }
  .content {
    flex: 1;
    min-height: 0;
  }
}
</style>
